<template>
    <div>
        <modal :show-title="true" :title="trans('general.daily_report.title')" size="lg" ref="dailyReportModal"
               v-model="showDailyReportModal" @close="close">

            <select-class v-if="!selectedChild && (!selectedClass || selectedClass?.id === 0)" v-on:selected-class="setClass"/>

            <daily-report-steps
                v-if="selectedChild || (selectedClass && selectedClass?.id !== 0)"
                :key="selectedChild?.id || selectedClass?.id"
                ref="dailyReportSteps"
                :child="selectedChild"
                :group="selectedClass"
                v-on:close="close"
                v-on:reload="reload"
                v-on:change-class="selectedClass = null"/>
        </modal>
    </div>
</template>

<script>
    import Modal from "../../theme/organisms/Modal.vue";
    import SelectClass from "./molecules/SelectClass.vue";
    import DailyReportSteps from "./organisms/DailyReportSteps.vue";
    import {eventBus} from "../../services/EventBus";

    export default {
        name: "DailyReport",
        props: {
            child: {
                type: Object,
                required: false
            },
            group: {
                type: Object,
                required: false
            },
        },
        components: {
            DailyReportSteps,
            Modal,
            SelectClass
        },
        data() {
            return {
                showDailyReportModal: false,
                selectedClass: this.group,
                selectedChild: this.child,
            };
        },
        methods: {
            init() {
                this.selectedChild = null;
                this.selectedClass = null;
                const selectedGroup = localStorage.getItem('selectedClass');

                if (selectedGroup && selectedGroup !== 'null') {
                    this.selectedClass = JSON.parse(selectedGroup);
                }
                this.open();
            },
            setClass(classData) {
                if(classData) {
                    localStorage.setItem('selectedClass', JSON.stringify(classData));
                }
                this.selectedClass = classData;
                this.selectedChild = null;
            },
            setChild(child) {
                this.selectedChild = child;
                this.selectedClass = null;
            },
            open() {
                this.showDailyReportModal = true;
            },
            close() {
                this.showDailyReportModal = false;
                if(this.$refs.dailyReportSteps) {
                    this.$refs.dailyReportSteps.reset();
                }
            },
            reload(data) {
                eventBus.$emit('child-report-updated', data);
            },
        },
    }
</script>
